import { Component, AfterViewInit, OnInit, ElementRef, ViewChild, Input, OnDestroy, DoCheck } from '@angular/core';
import { Dropdown } from '@eds/vanilla/dropdown/Dropdown';
import * as _ from 'lodash';
import { userUsageDataService } from '../service/userUsage.data.service';
import { saveAs } from 'file-saver';
import {LineChart} from '@eds/vanilla/charts/line-chart/LineChart';
import {Donut} from '@eds/vanilla/charts/donut/Donut';
import { each } from 'underscore';
declare var jQuery: any;
@Component({
  selector: 'app-data-users-component',
  templateUrl: './data-users-component.component.html',
  styleUrls: ['./data-users-component.component.css']
})
export class DataUsersComponentComponent implements OnInit, OnDestroy, DoCheck, AfterViewInit {

  subscription = [];

  // @ViewChild("dropdowns", {static: false})
  // private elDropdowns: ElementRef;
  @Input() dataFiltered: string;
  @ViewChild('menu', {static: false})
  private elMenus: ElementRef;

  @ViewChild('useractivitydrop', {static: false})
  private useractivityMenu: ElementRef;

  @ViewChild('usertrenddrop', {static: false})
  private usertrendMenu: ElementRef;

  @ViewChild('totaluserdrop', {static: false})
  private totaluserMenu: ElementRef;

  @ViewChild('newuserdrop', {static: false})
  private newuserMenu: ElementRef;

  isNaN: Function = Number.isNaN;
  
  studentLoginSum: any;
  teacherLoginSum: any;
  adminLoginSum: any;

  ctlStudentAppSum: any;
  internetBrowserSum: any;
  othersSum: any;
  ctlStudentJson: any;
  usertoDeviceAvg: any;
  userOverviewUsageData_new: any;
  deviceOverviewData: any;
  applicationOverviewData: any;
  contentOverviewData: any;

  lineChartData: any;
  tabletDeployedSum: any;
  laptopDeployedSum: any;
  tabletUsedSum: any;
  laptopUsedSum: any;


  overviewstudentTabletAgg: any;
  overviewstudentLaptopAgg: any;
  overviewteacherTabletAgg: any;
  overviewteacherLaptopAgg: any;
  overviewadminTabletAgg: any;
  overviewadminLaptopAgg: any;

  studentTabletAgg: any;
  studentLaptopAgg: any;

  teacherTabletAgg: any;
  teacherLaptopAgg: any;

  adminTabletAgg: any;
  adminLaptopAgg: any;
  edsDonutData1:any;
  edsDonutData2:any;
  edsDonutData3:any;

  items: any;
  userOverviewUsageData = [];
  sumofUsersItems: any = [];
  userUsageData: any;
  lineChartLoaded = false;
  donutChartLoaded1 = false;
  donutChartLoaded2 = false;
  donutChartLoaded3 = false;
  st = 120;
  teach = 120;
  adm = 120;
  edslineData01: any;
  data_01 = [];
  fontBig = '64px';
  fontSmall = '44px';

  settings_01 = {
    selector: 'userActivityChart',
    width: 260,
    height: 260,
    hole: 120,
    colors : ['#813aa1', '#11c273', '#1a609b'],
    total: 'sum',
    totalText: 'Total Logins'
  };

  data_01_01 = [];
  eds_lin_data_01 : any
  data02 = [];

  settings02 = {
    selector: 'registeredUsersChart',
    width: 260,
    height: 260,
    hole: 120,
    colors : ['#813aa1', '#11c273', '#1a609b'],
    total: 'sum',
    totalText: 'Registered Users'
  };
  timerId: any;
  regusers = [];
  data03 = [];

  settings03 = {
    selector: 'newUsersChart',
    width: 260,
    height: 260,
    hole: 120,
    colors : ['#813aa1', '#11c273', '#1a609b'],
    total: 'sum',
    totalText: 'New Registrations'
  };
  newusers = [];
  userTrendChartData = [];
  userTrendChartSetting = {
    selector: 'userActivityTrendChart',
    width: 800,
    height: 244,
    colors : [ '#813aa1', '#11c273', '#1a609b']
  };
  textDir:any;
  constructor( private userUsageService: userUsageDataService ) {
    this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.loadAllSectionsData();
  }

  ngOnDestroy() {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    });
  }

  ngDoCheck() {
    
     if (document.getElementById('default-line-chart')){
      if (!this.lineChartLoaded && document.getElementById('default-line-chart').clientHeight > 0){
        document.getElementById('default-line-chart').innerHTML = '';
        //console.log("users tab")
        this.linechartInit();
        setTimeout(function(){​​​​ 
          jQuery('#default-line-chart').find('rect').attr('pointer-events','none');
        }​​​​, 1000);
        this.lineChartLoaded = true;
      }
    } 

  
  }

  ngAfterViewInit() {
    const useractivityDrop = new Dropdown(this.useractivityMenu.nativeElement);
    useractivityDrop.init();
    const usertrendDrop = new Dropdown(this.usertrendMenu.nativeElement);
    usertrendDrop.init();
    const totaluserDrop = new Dropdown(this.totaluserMenu.nativeElement);
    totaluserDrop.init();
    const newuserDrop = new Dropdown(this.newuserMenu.nativeElement);
    newuserDrop.init();
  }
linechartInit(){

  document.getElementById('default-line-chart').innerHTML="";
  const linechart = new LineChart({
    element: document.getElementById('default-line-chart'),
    data: this.lineChartData,
    height: 250,
    margin: {
      left: 45,
    },
    y: {
      unit: 'Visits',
    },
    tooltip: {
      format: {
        title: '%d %B',
        value: 'd',
      }
    }
  });
  
  linechart.init();
  
}

donutChartInit_01(){
  document.getElementById('totaldonut1').innerHTML="";
  const chart01 = new Donut({
    element: document.getElementById('totaldonut1'),
    data: this.edsDonutData1,     
    showValue: true,
    showAbsoluteValue: true,
    unit: 'Total logins'
  });
  chart01.init();
 
}
donutChartInit_02(){
  document.getElementById('totaldonut2').innerHTML="";
  const chart02 = new Donut({
    element: document.getElementById('totaldonut2'),
    data: this.edsDonutData2,
    showValue: true,
    unit: 'Registered users'
  }); 
  chart02.init();
     
}
donutChartInit_03(){
  document.getElementById('totaldonut3').innerHTML="";
  const chart03 = new Donut({
    element: document.getElementById('totaldonut3'),
    data: this.edsDonutData3,
    showValue: true,
    unit: 'Registered users'
  }); 
  chart03.init();
     
}

  loadAllSectionsData() {
    const sub = this.userUsageService.userUsage$Data.subscribe(data => {
      // all load data service
      this.userUsageService.getUserActivityOverviewData();
      this.userUsageService.getUserActivityOverviewPerData();
      this.userUsageService.getUserActivityTrendData();
      this.userUsageService.getTotalUsersData();
      this.userUsageService.getTotalUsersPerData();
      this.userUsageService.getNewUsersData();
      this.userUsageService.getNewUsersPerData();
      // all data subscription
      this.getUserActivityOverview();
      this.getUserActivityTrend();
      this.getTotalUsers();
      this.getNewUsers();
     
      /* this.donutChartInit_02();
      this.donutChartInit_03(); */
      
    });
    this.subscription.push(sub);
  }

  getUserActivityOverview() {
    const sub1 = this.userUsageService.loginActivity$Data.subscribe(data => {
      this.data_01 = [...data];
     /// this.edsDonutData1.push({name: 'test', value: ['300'], colorID: '3'});
     
     const edsDataObj = [];
     this.data_01.forEach((a,index )=> {
         const dataObj = {name: a.id, values: [a.count], colorID: (index+1).toString()};
         edsDataObj.push(dataObj);
       });
      // this.edsDonutData1 = {series: edsDataObj};
       const nodataObj3 =[{name:"Teacher",values:[200],colorID:"1"}];
      
       if(this.data_01.length>0){
         this.edsDonutData1 = {"series": edsDataObj};
       }else{
         this.edsDonutData1 = {"series": nodataObj3};
       }
    
    
 
     this.donutChartInit_01();

    });
   
    this.subscription.push(sub1);
    const sub2 = this.userUsageService.loginActivityPer$Data.subscribe(data => {
      this.data_01_01 = [...data];
     // console.log("data_01_01 >>> "+JSON.stringify(this.data_01_01))
      if(this.data_01_01.length==0){
        this.data_01_01 = [{"role":"Teacher","total":0,"Tablet":0,"Laptop":0},{"role":"Student","total":0,"Tablet":0,"Laptop":0},{"role":"Project Admin","total":0,"Tablet":0,"Laptop":0}];

      }
      
    });
    this.subscription.push(sub2);
  }

  getUserActivityTrend() {
    const sub = this.userUsageService.userTrend$Data.subscribe(data => {
      this.userTrendChartData = [...data];


      const commonArr = [];
      const valuesArr = [];
  
       // let edsLineDataObj1 = [{"count":"80","date":"2019-11-11T18:30:00.000Z"},{"count":"80","date":"2019-11-12T18:30:00.000Z"}]
      let idArr = '';
      this.userTrendChartData.forEach((a, index ) => {
        idArr = a.id;
        // KAJAL
        for ( const items of a.values ){
          valuesArr.push(items.count);
          commonArr.push(items.date);
        }
      });
  
     
      
      let common = ["2018-11-14","2018-11-13","2018-11-12","2018-11-11","2018-11-10"]
      let series = [{name:"Ethernet/Wi-fi/SIM",values:["0","10","20","30","40"]},{name:"No Connection", values:["0","10","20","30","40"]}]
      
      
      if(this.userTrendChartData.length>0){
        this.lineChartData = {series: [{name: idArr, values: valuesArr}], common:commonArr};

        /* setTimeout(function(){​​​​ 
          jQuery('#default-line-chart').find('rect').attr('pointer-events','all');
        }​​​​, 1000); */
      }else{
        this.lineChartData = {series: series, common:common};
      /*   setTimeout(function(){​​​​ 
          jQuery('#default-line-chart').find('rect').attr('pointer-events','none');
        }​​​​, 1000); */
      }
      this.linechartInit();
    });
    // console.log("userTrendChartData >>> "+JSON.stringify(this.userTrendChartData));

  
     //console.log("lineChartData final >>> "+JSON.stringify(this.lineChartData));
    this.subscription.push(sub);
  }

  getTotalUsers() {
    const sub1 = this.userUsageService.totalUsers$Data.subscribe(data => {
      this.data02 = [...data];
      //console.log("daata02 janaanaaakaki >>> "+JSON.stringify(this.data02));
      const edsDataObj = [];
      this.data02.forEach((a,index )=> {
          const dataObj = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj.push(dataObj);
        });
        this.edsDonutData2 = {series: edsDataObj};
        const nodataObj2 =[{name:"Teacher",values:[200],colorID:"1"}]
     
        if(this.data02.length>0){
          this.edsDonutData2 = {"series": edsDataObj};
  
        }else{
  
          this.edsDonutData2 = {"series": nodataObj2};
        }
        //console.log("daata02 janaanaaajanaaanananankaki >>> "+JSON.stringify(this.edsDonutData2));
    });
   
    this.subscription.push(sub1);
    const sub2 = this.userUsageService.totalUsersPer$Data.subscribe(data => {
      this.regusers = [...data];
      if(this.regusers.length==0){
       // this.regusers = [{"role":"Teacher","total":0,"Tablet":0,"Laptop":0}];
        this.regusers = [{"role":"Teacher","total":0,"Tablet":0,"Laptop":0},{"role":"Student","total":0,"Tablet":0,"Laptop":0},{"role":"Project Admin","total":0,"Tablet":0,"Laptop":0}];

      }
      this.donutChartInit_02();
    });
   /*  if (document.getElementById('totaldonut2')){
      document.getElementById('totaldonut2').innerHTML = '';
      } */
   
    this.subscription.push(sub2);
  }

  getNewUsers() {
    const sub1 = this.userUsageService.newUsers$Data.subscribe(data => {
      this.data03 = [...data];
      //console.log("totaldonut3 data03>>>>>>>>>> "+JSON.stringify(this.data03))
      const edsDataObj = [];
      this.data03.forEach((a,index )=> {
          const dataObj = {name: a.id, values: [a.count], colorID: (index+1).toString()};
          edsDataObj.push(dataObj);
        });
      
        const nodataObj3 =[{name:"Teacher",values:[200],colorID:"1"}]
     
        if(this.data03.length>0){
          this.edsDonutData3 = {"series": edsDataObj};
  
        }else{
  
          this.edsDonutData3 = {"series": nodataObj3};
        }
    });
    this.subscription.push(sub1);

    const sub2 = this.userUsageService.newUsersPer$Data.subscribe(data => {
      this.newusers = [...data];
      if(this.newusers.length==0){
       // this.newusers = [{"role":"Teacher","total":0,"Tablet":0,"Laptop":0}];
        this.newusers = [{"role":"Teacher","total":0,"Tablet":0,"Laptop":0},{"role":"Student","total":0,"Tablet":0,"Laptop":0},{"role":"Project Admin","total":0,"Tablet":0,"Laptop":0}];

        
      }
      this.donutChartInit_03();
    });
   /*  if (document.getElementById('totaldonut3')){
      document.getElementById('totaldonut3').innerHTML = '';
      } */
     // console.log("new Reg users janakir>>>>>>>>>> "+JSON.stringify(this.newusers))

    this.subscription.push(sub2);
  }

  generateCSV(section: any) {
    if (section === 'users-activity') {
      const csv = this._objectArrayToCsv(this.data_01_01);
      this._downloadFile(section, csv);
    }
    if (section === 'users-trend') {
      let csv = new Array();
      this.userTrendChartData.forEach(item => {
        csv.push(item.id);
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(item.values));
        csv.push('');
      });
      this._downloadFile(section, csv);
    }
    if (section === 'total-users') {
      const csv = this._objectArrayToCsv(this.regusers);
      this._downloadFile(section, csv);
    }
    if (section === 'new-users') {
      const csv = this._objectArrayToCsv(this.newusers);
      this._downloadFile(section, csv);
    }
  }

  _downloadFile(section, csv) {
    const csvArray = csv.join('\r\n');
    const blob = new Blob([csvArray], {type: 'text/csv' })
    saveAs(blob, 'overview-' + section + '.csv');
  }

  _objectArrayToCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    return csv;
  }
}
